import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=19d09de7&"
import script from "./CollectionCard.vue?vue&type=script&lang=ts&"
export * from "./CollectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports